<cb-lot-spec-item-icons [mappedItem]="mappedItem"></cb-lot-spec-item-icons>
<cb-td-text #codeCol [value]="mappedItem.productCode"></cb-td-text>
@if (!(mappedItem.isManualQuote && mappedItem.isQuoteCost)) {
    <span>
        <cb-td-text [value]="mappedItem.productDisplay"></cb-td-text>
    </span>
}
@if (mappedItem.isManualQuote && mappedItem.isQuoteCost) {
    <span>
        <cb-td-text [value]="mappedItem.quoteLineDescription"></cb-td-text>
    </span>
}
<cb-td-text #categoryCol [value]="mappedItem.productCategory"></cb-td-text>
<cb-td-enum [value]="mappedItem.costType" [enum]="COST_TYPE_ENUM"></cb-td-enum>
<cb-td-text #supplierCol [value]="mappedItem.supplierDisplay"></cb-td-text>
<td
    [delayed]="false"
    (cbAfterInit)="
        colWidthSyncService.update(
            mappedItem.id,
            codeCol?.elementRef?.nativeElement,
            categoryCol?.elementRef?.nativeElement,
            supplierCol?.elementRef?.nativeElement
        )
    "
    (cbOnResize)="
        colWidthSyncService.update(
            mappedItem.id,
            codeCol?.elementRef?.nativeElement,
            categoryCol?.elementRef?.nativeElement,
            supplierCol?.elementRef?.nativeElement
        )
    "
    (cbOnDestroy)="colWidthSyncService.delete(mappedItem.id)"
    cbTableShrinkCol
    cbTableStickyCol="end"
>
    <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>more_horiz</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
        @if (!uiActions.hideQrefsButton()) {
            <button
                mat-menu-item
                (click)="uiActions.quoteRefsDialog()"
                [disabled]="!mappedItem.hasQuoteLines"
            >
                Q Refs
            </button>
        }
        @if (mappedItem.isSsrConfirmed) {
            <button mat-menu-item (click)="uiActions.showPurchaseOrders()">PO's</button>
        }
        @if (uiActions.showSplitSpecItem()) {
            <button
                mat-menu-item
                (click)="uiActions.splitProduct()"
                [disabled]="!mappedItem.canSplit"
            >
                Split
            </button>
        }
        @if (uiActions.canChangeSpecification()) {
            <button
                mat-menu-item
                (click)="uiActions.editLotSpecItem()"
                [disabled]="!mappedItem.canEdit"
            >
                Edit
            </button>
        }
        @if (uiActions.canChangeSpecification()) {
            <button
                mat-menu-item
                (click)="uiActions.removeLotSpecItem()"
                [disabled]="lotSpec?.isLocked"
            >
                Remove
            </button>
        }
    </mat-menu>
</td>
